var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', [_vm._l(_vm.ebookProducts, function (ebookProduct, index) {
    return [_c('v-layout', {
      key: "company" + index
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_vm._v("ebook 업체")]), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('v-select', {
      attrs: {
        "disabled": !_vm.$hasScope(['root', 'admin']),
        "items": _vm.ebookCompanies,
        "item-text": "name",
        "item-value": "_id",
        "outlined": "",
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: ebookProduct._ebookCompany,
        callback: function callback($$v) {
          _vm.$set(ebookProduct, "_ebookCompany", $$v);
        },
        expression: "ebookProduct._ebookCompany"
      }
    })], 1)], 1), _c('v-layout', {
      key: index,
      staticClass: "mt-4"
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_vm._v("ebook URL")]), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": !_vm.$hasScope(['root', 'admin']),
        "outlined": "",
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: ebookProduct.ebookValue,
        callback: function callback($$v) {
          _vm.$set(ebookProduct, "ebookValue", $$v);
        },
        expression: "ebookProduct.ebookValue"
      }
    })], 1)], 1)];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }